import React from 'react'
import { Helmet } from 'react-helmet';
import Header from '../../components/Header/Header'
import styles from './Plans.scss';

const PlanDc = ({ changeTheme, themeBlack }) => {
  return (
    <div>
      <Helmet>
        <title>Финансовое планирование DC</title>
      </Helmet>

      <div className="frame-box">
        <iframe src="https://docs.google.com/spreadsheets/d/19rhS9OeEv8yGKzrF9cUb8kSz4HrpVJRjJSLPyzOvY08" frameBorder="0"></iframe>
      </div>
    </div>
  )
}

export default PlanDc